import { appAjsModule } from "./app.module.ajs"
export const AppAjsBootstrapModule = angular
    .module('appAjsBootstrapModule', [appAjsModule])